import SingleSnAdditionalInfoAccordion from "./singleSnAdditionalInfoAccordion.container";

export default SingleSnAdditionalInfoAccordion;
